import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/sets/$setId/modules")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
